//@flow
import ExperimentsStore from './experimentsStoreClass';

export default new ExperimentsStore();
